<blockquote>
  @if ((quote?.quoteImg?.url || quote?.quoteImg?.urlTwicPic)) {
    <sd-banner [isComponentLoading]="isLoading"
      [media]="quote?.quoteImg"
      [hasAltText]="false"
      [isFit]="true"
      [imgRatio]="imageRatioEnum.r1_1"
      data-testid="sd-banner"
    />
  } @else {
    <sd-icon name="icon-quote" [brand]="brand" [size]="iconSizeEnum.medium" data-testid="icon-quote"/>
  }

  @if (isLoading) {
    <sd-skeleton
      [appearance]="skeletonAppearanceEnum.line"
      [width]="80"
      [center]="true"
      [sizeChangeMobile]="false"
      [count]="1"
      data-testid="default-skeleton"
    />
  }

  @if (quote?.quote && !isLoading) {
    <p class="{{isEditorial ? 'brand--h4 is-text-center' : 'brand--h3'}}" data-testid="quote-paragraph">
      {{ quote?.quote }}
    </p>
  }

  @if (quote?.author) {
    <footer data-testid="footer">
      @if (!isLoading) {
        <cite class="brand--h5 is-text-center" data-testid="quote-author-cite">
          {{ quote?.author }}
        </cite>
      }
      @if (isLoading) {
        <sd-skeleton
          [width]="30"
          [center]="true"
          [appearance]="skeletonAppearanceEnum.line"
          [sizeChangeMobile]="false"
          [count]="1"
          data-testid="author-skeleton"
        />
      }
    </footer>
  }
</blockquote>
